import { Page } from "@/models/page-models/Page";

export const PurchaseOrderUpdateAccounts: Page = {
  "path": "edit-purchase-order/:poId",
  "name": "Edit Purchase Order",
  "props": {
    "data": {
      "title": "Edit Purchase Order",
      "printable": "TRUE",
      "url": "edit-purchase-order/:poId",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.supplier._id",
                  "label": "Select Supplier",
                  "disabled": "TRUE",
                  "items": "fetchedData.supplierList.data",
                  "itemText": "name",
                  "itemValue": "_id"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Supplier Shipping Info"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedPoData.supplierPort",
                  "label": "Supplier Port",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.currencyCode",
                  "label": "Currency Code",
                  "disabled": "TRUE",
                  "items": "[\"EUR\",\"USD\",\"SAR\",\"AED\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedPoData.deliveryTerms",
                  "label": "Delivery Terms",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.paymentTerms",
                  "label": "Payment Terms",
                  "disabled": "TRUE",
                  "items": "[\"CAD (Cash Against Documents)\",\"DFT30 (Draft 30 days from B/L Date)\",\"DFT60 (Draft 60 days from B/L Date)\",\"DFT90 (Draft 90 days from B/L Date)\",\"DFT120 (Draft 120 days from B/L Date)\",\"LC SGHT (ICLC Payable at Sight)\",\"LC30 (ICLC 30 days from B/L Date)\",\"LC45 (ICLC 45 days from B/L Date)\",\"LC60 (ICLC 60 days from B/L Date)\",\"LC90 (ICLC 90 days from B/L Date)\",\"LC120 (ICLC 120 days from B/L Date)\",\"TLX ADV (Advance Telex Transfer)\",\"TLX (Telex Transfer Upon Receipt)\",\"CHQ30 (Cheque 30 days on Goods Receipt)\",\"CHQ45 (Cheque 45 days on Goods Receipt)\",\"CHQ60 (Cheque 60 days on Goods Receipt)\",\"Cash\",\"FOC\",\"CHQ 75 Days from Date of Shipping\",\"CHQ 90 Days from Date of Shipping\",\"On Account\",\"TLX Transfer 120 Days from BL/TWB DATE\",\"TLX Transfer 90 Days from BL/TWB DATE\",\"TLX Transfer 60 Days from BL/TWB DATE\",\"TLX Transfer 30 Days from B/L DATE\",\"Cash in Advance Prior to Shipment By ...\",\"Advance 30% and CAD 70%\",\"Avalised Draft 90 days from BL/TWB Date\",\"Avalised Draft 60 days from B/L Date\",\"CAD 30 days with 2% discount on Invoice\",\"CAD 60 days from B/L Date\",\"CAD 75 days from B/L Date\",\"CAD 90 days from B/L Date\",\"CAD 120 days from B/L Date\",\"CAD 60 days from Invoice Date\",\"CAD 90 days from Invoice Date\",\"CAD 120 days from Invoice Date\",\"Telex Transfer - 50% Advance & 50% Before ...\",\"CAD 60 days\",\"CAD 90 days\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.packingMode",
                  "label": "Packing Mode",
                  "disabled": "TRUE",
                  "items": "[\"None\",\"Wrapped Rolls for Sea Worthy Shipment\",\"In brand new Steel Drums on Pallet ...\",\"In Rolls, Wrapped and Protected\",\"In Carton Box on Pallets Wrapped\",\"In Rolls, Wrapped and Protected with ...\",\"Wrapped Board For Seaworthy Shipment\",\"Usual Packing\",\"Carton Box\",\"In Rolls, Protected with Strong\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.bankCode",
                  "label": "Bank Code",
                  "disabled": "FALSE",
                  "items": "[\"Documents delivered to Consignee directly\",\"Arab National Bank\",\"National Commercial Bank\",\"Samba Financial Group\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.shippingMarks",
                  "label": "Shipping Marks",
                  "disabled": "TRUE",
                  "items": "[\"Made In Germany\",\"Made In Brazil\",\"Made In Canada\",\"Made In India\",\"Made In Denmark\",\"Made In Belgium\",\"Made In U.S.A\",\"Made In China\",\"Made In Indonesia\",\"Made In Korea\",\"Made In K.S.A\",\"Made In Qatar\",\"Made in Sweden\",\"Made in France\",\"Made in Turkey\",\"Made in Spain\",\"Made in UAE\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.shippingMode",
                  "label": "Shipping Mode",
                  "disabled": "TRUE",
                  "items": "[\"Ocean Vessel 20FT Container\",\"Ocean Vessel 40FT Container\",\"Ocean Vessel Break Bulk(Pallets)/ Tons ( LCL Shipment)\",\"Groupage Container Ocean Vessel\",\"Air Freight\",\"Air Post Parcel\",\"Van\",\"DHL Courier Service\",\"Purchaser\",\"Sea Freight\",\"Supplier\",\"Truck\",\"Road Tanker\",\"Ocean Vessel 20FT ISO Tanker\",\"None\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "datepicker",
                  "variable": "fetchedData.selectedPoData.shippingDate",
                  "label": "Shipping Date",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "6",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "fetchedData.selectedPoData.eta",
                  "label": "ETA/ATA(Port)",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "formData.packFreight",
                  "label": "Pack + Freight",
                  "unit": "SAR",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedPoData.ataWarehouse",
                  "label": "ATA(Warehouse)",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "7",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.seaFreight",
                  "label": "Sea Freight",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.vesselName",
                  "label": "Vessel Name\n",
                  "disabled": "FALSE"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.insuranceCode",
                  "label": "Insurance Code",
                  "disabled": "FALSE",
                  "items": "[\"Spare Parts\",\"Inks/Additives\",\"PE/Films\",\"Inks/Solvents/Films/Paper/Alu\",\"PE/Masterbatch/Additives/Machines & Spare Parts\",\"Masterbatch\",\"None\"]",
                  "dropdownType": "static"
                }
              ]
            },
            {
              "name": "8",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.packingCost",
                  "label": "Packing Cost",
                  "unit": "{{fetchedData.selectedPoData.currencyCode}}",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.insuranceCost",
                  "label": "Insurance Cost",
                  "unit": "{{fetchedData.selectedPoData.currencyCode}}",
                  "disabled": "FALSE"
                },
                {
                  "type": "input",
                  "variable": "formData.inlandCode",
                  "label": "Inland Code",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "9",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.inlandFreight",
                  "label": "Inland Freight",
                  "disabled": "FALSE",
                  "items": "[\"Dammam Port - Truck\",\"Dammam Port - Trailer\",\"Jeddah Port - Truck\",\"Jeddah Port - Trailer\",\"Khalidia Port - Truck\",\"Khalidia Port - Trailer\",\"1st Industrial Area Port - Truck\",\"1st Industrial Area Port - Trailer\",\"None\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "fetchedData.selectedPoData.homePort",
                  "label": "Home Port",
                  "disabled": "TRUE",
                  "items": "[\"Dammam\",\"Jeddah\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "input",
                  "variable": "fetchedData.selectedPoData.notes",
                  "label": "Additional Notes",
                  "disabled": "TRUE"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "fetchedData.selectedPoData.requiredDocuments",
          "label": "Documents Required",
          "disabled": "TRUE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "name"
                },
                {
                  "type": "input",
                  "variable": "original",
                  "label": "Original",
                  "disabled": "TRUE",
                  "fixedWidth": true
                },
                {
                  "type": "input",
                  "variable": "copy",
                  "label": "Copy",
                  "disabled": "TRUE",
                  "fixedWidth": true
                }
              ]
            }
          ],
          "initialValue": [
            {
              "name": "Invoice"
            },
            {
              "name": "Certificate of Origin"
            },
            {
              "name": "B/L/AWB"
            },
            {
              "name": "Packing List"
            },
            {
              "name": "Insurance Certificate"
            },
            {
              "name": "Certificate of Analysis"
            }
          ],
          "disableAddDelete": true
        },
        {
          "type": "arrayGroup",
          "variable": "fetchedData.selectedPoData.additionalDocuments",
          "disabled": "TRUE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "name",
                  "label": "Name",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "original",
                  "label": "Original",
                  "disabled": "TRUE",
                  "fixedWidth": true
                },
                {
                  "type": "input",
                  "variable": "copy",
                  "label": "Copy",
                  "disabled": "TRUE",
                  "fixedWidth": true
                }
              ]
            }
          ],
          "initialArrayLength": 0
        },
        {
          "type": "arrayGroup",
          "variable": "fetchedData.selectedPoData.purchasedRMs",
          "label": "Raw Materials",
          "disabled": "FALSE",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "rawMaterial._id",
                  "label": "Raw Material",
                  "disabled": "TRUE",
                  "items": "fetchedData.goods.data",
                  "itemText": "mainSpecification",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,goodsName,{{__item}})"
                },
                {
                  "type": "input",
                  "variable": "unitQuantity",
                  "label": "Quantity",
                  "unit": "{{__arrayGroup3.rawMaterial.rawMaterialUnit}}",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "tolerance",
                  "label": "Tolerance",
                  "unit": "%",
                  "disabled": "TRUE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "unitPrice",
                  "label": "Unit Price",
                  "unit": "{{formData.currencyCode}}",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "exemption",
                  "label": "Customs RM Name",
                  "disabled": "TRUE"
                },
                {
                  "type": "input",
                  "variable": "landedWarehouseCost",
                  "label": "Landed Warehouse Cost",
                  "unit": "{{formData.currencyCode}}",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "printable": false,
          "style": "border"
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "createCurrentPurchasedRMsArray"
                    },
                    {
                      "executionOrder": 2,
                      "name": "updatePO"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Print",
                  "disabled": "FALSE",
                  "color": "secondary",
                  "buttonType": "print"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "PO Table",
                  "disabled": "TRUE",
                  "items": "fetchedData.selectedPoData.purchasedRMs",
                  "headers": [
                    {
                      "value": "__item.rawMaterial",
                      "text": "Material Descriptions",
                      "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})"
                    },
                    {
                      "value": "__item.rawMaterial.rawMaterialUnit",
                      "text": "Unit"
                    },
                    {
                      "value": "__item.unitQuantity",
                      "text": "Quantity",
                      "type": "formula",
                      "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.unitQuantity}},{{__item.rawMaterial}})}},{{__item.unitQuantity}})"
                    },
                    {
                      "value": "__item.unitPrice",
                      "text": "Unit Price {{formData.currencyCode}}",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,priceKgToSQM,{{__item.unitPrice}},{{__item.rawMaterial}})}},{{__item.unitPrice}}))"
                    },
                    {
                      "value": "__item.total",
                      "text": "Total {{formData.currencyCode}}",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,{{{{__item.unitQuantity}} * {{__item.unitPrice}}}})"
                    },
                    {
                      "value": "__item.VAT",
                      "text": "Vat @ {{fetchedData.companyDetails.data.0.data.vatPercentage}}% {{formData.currencyCode}}",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01,{{__item.unitQuantity}},{{__item.unitPrice}}))",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false }}"
                    },
                    {
                      "value": "__item.totalPrice",
                      "text": "Total Price {{formData.currencyCode}}",
                      "type": "formula",
                      "formula": "fn(HELPER_FN,numFormat,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__item.unitQuantity}},{{__item.unitPrice}}))",
                      "showIf": "{{{{fetchedData.selectedSupplier.data.isInternational}} === false }}"
                    }
                  ],
                  "printable": true,
                  "tableType": "static",
                  "showActions": false
                }
              ]
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Quantity",
                  "labelType": "formula",
                  "formula": "fn(KEYED_ARRAY_SUM,fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__arrayItem.rawMaterial.rawMaterialUnit}},'),==,'SQM'),fn(STANDARD_FUNCTIONS,kgToSQM,{{__arrayItem.unitQuantity}},{{__arrayItem.rawMaterial}}),{{__arrayItem.unitQuantity}}),{{fetchedData.selectedPoData.purchasedRMs}},_id)",
                  "filterType": "unit",
                  "filterParam": "{{formData.purchasedRMs.0.rawMaterial.rawMaterialUnit}}",
                  "printable": false
                }
              ]
            },
            {
              "name": "5",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Total Amount",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,fn(KEYED_ARRAY_SUM,fn(MULTIPLY,fn(SUM,fn(MULTIPLY,{{fetchedData.companyDetails.data.0.data.vatPercentage}},0.01),1),{{__arrayItem.unitQuantity}},{{__arrayItem.unitPrice}}),{{fetchedData.selectedPoData.purchasedRMs}},_id))",
                  "printable": false
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getAllSuppliers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/suppliers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.supplierList"
        },
        "name": "getAllSuppliers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Commercial | Purchaser))"
      },
      {
        "executionOrder": 1,
        "name": "getRMs"
      },
      {
        "executionOrder": 2,
        "name": "getPoDetails"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCompanyDetails",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/staticdata?type=company-detail",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.companyDetails"
        },
        "name": "getCompanyDetails"
      }
    ],
    "functions": [
      {
        "name": "getRMs",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/rm",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.goods"
      },
      {
        "name": "getPoDetails",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/purchaseorder/{{__params.poId}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.poDetails",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "[{\"name\":\"copyPoData\",\"executionOrder\":1},{\"name\":\"copyLandedWarehouseFields\",\"executionOrder\":2}]"
      },
      {
        "name": "copyPoData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "fetchedData.poDetails.data",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedPoData"
      },
      {
        "name": "updatePO",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/purchaseorder/{{__params.poId}}",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "fnsAfterSubmit",
        "arg3Value": "redirectToViewPOs",
        "arg4Key": "requestMethod",
        "arg4Value": "PATCH"
      },
      {
        "name": "redirectToViewPOs",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/purchase-order-accounts"
      },
      {
        "name": "createCurrentPurchasedRMsArray",
        "type": "fnCreateArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.selectedPoData.purchasedRMs",
        "arg2Key": "destinationVariable",
        "arg2Value": "formData.purchasedRMs",
        "arg3Key": "arrayTransformationFn",
        "arg3Value": "getLandedWarehouseCost"
      },
      {
        "name": "getLandedWarehouseCost",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "landedWarehouseCost": "__selectedObject.landedWarehouseCost"
        }
      },
      {
        "name": "copyLandedWarehouseFields",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getLandedWarehouseFields",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE"
      },
      {
        "name": "getLandedWarehouseFields",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "bankCode": "fetchedData.selectedPoData.bankCode",
          "packFreight": "fetchedData.selectedPoData.packFreight",
          "seaFreight": "fetchedData.selectedPoData.seaFreight",
          "vesselName": "fetchedData.selectedPoData.vesselName",
          "insuranceCode": "fetchedData.selectedPoData.insuranceCode",
          "packingCost": "fetchedData.selectedPoData.packingCost",
          "insuranceCost": "fetchedData.selectedPoData.insuranceCost",
          "inlandCode": "fetchedData.selectedPoData.inlandCode",
          "inlandFreight": "fetchedData.selectedPoData.inlandFreight",
          "supplierPort": "fetchedData.selectedPoData.supplierPort"
        }
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}